import {
  displayFormattedDate,
  removeWebpackErrorOverlay,
} from "./commonService";
import iq_api from "./iqApi";
import api from "./api";
import iq_api_v2 from "../services/iqApiV2";
import qs from "qs";

// Function to fetch account info
export const fetchAccountInfo = async (accountName) => {
  if(!accountName){
    return []
  }
  try {
    const response = await iq_api.post("/chatgpt/account_details", {
      account_name: accountName,
    });

    let result = response?.data?.records?.[0] ?? [];
    // console.log(result);
    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Account details error:", error);
    throw error;
  }
};

export const fetchAccountDetails = async (
  accountId,
  accountName,
  clientName
) => {
  try {
    const response = await iq_api.post("/chatgpt/account_all_details", {
      account_name: accountName,
      client_name: clientName,
    });

    let result = response?.data?.records ?? [];

    delete result.business_unit_overview_extra;

    // Reform overview text data
    let overview = result.overview;
    let transformed_overview = overview?.[0]?.data?.[0]?.text || "";
    result.overview = transformed_overview;
    // End: Reform overview text data

    // Reform key products and services data
    let key_products_services = result?.key_products_services || [];
    /*
    let transformed_key_products_services = key_products_services?.map(bu => ({
        "bu_name": bu._id.business_unit,
        "products_and_services": bu.data[0].data.map(product => ({
            "name": product.name,
            "description": product.description || ""
        })
        )
    }));
    */

    // console.log(key_products_services)

    let transformed_key_products_services =
      key_products_services?.map((bu) => {
        try {
          return {
            bu_name: bu?._id?.business_unit || "", // Safely access business_unit or fallback to 'N/A'
            products_and_services:
              bu?.data?.[0]?.data?.map((product) => {             
                try {
                  return{ 
                    name: product?.name || "", // Fallback to a default if name is missing
                    description: product?.description || "", // Safely handle description or provide an empty string
                    }
                } catch (error) {
                  console.log("err",error)
                }           
            }) || [], // Ensure an empty array if bu.data[0].data is invalid or missing
          }
        } catch (error) {
        
          console.log("error ",error)
        }
       }) || []; // Return an empty array if key_products_services is undefined or null

    // Filter product name if blank
    transformed_key_products_services = transformed_key_products_services.map(
      (bu) => (bu?.products_and_services && {
        ...bu,
        products_and_services: bu?.products_and_services.filter(
          (ps) => ps.name.trim() !== ""
        ),
      })
    );
    /* .filter(bu => bu.products_and_services.length > 0) */
    // End: Filter product name if blank
    // console.log('transformed_key_products_services', transformed_key_products_services);

    result.key_products_services = transformed_key_products_services || [];
    // End: Reform key products and services data

    // Reform strategic priorities data
    let strategic_priorities = result.strategic_priorities;
    let transformed_strategic_priorities =
      strategic_priorities?.[0]?.data?.[0]?.data || [];
    result.strategic_priorities = transformed_strategic_priorities;
    // End: Reform strategic priorities data

    // console.log(result);
    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Account details error:", error);
    throw error;
  }
};
export const fetchAccountCompetitors = async (
  accountId,
  accountName,
  clientName
) => {
  try {
    const response = await iq_api.post("/competitors/global-competitors", {
      account_name: accountName,
      client_name: clientName,
    });

    let result = response?.data?.records ?? [];

    let finalResult = {};
    finalResult.competitors = result?.competitors || [];

    return finalResult;
  } catch (error) {
    console.log(error);
    console.error("Fetch Account details error:", error);
    throw error;
  }
};

export const fetchBusinessUnitAccountDetails = async (
  accountName,
  clientName,
  business_unit
) => {
  try {
    const response = await iq_api.post(
      "/chatgpt/account_details_by_business_unit",
      {
        account_name: accountName,
        client_name: clientName,
        business_unit: business_unit,
      }
    );

    let result = response?.data?.records ?? [];

    let finalResult = {};

    finalResult.account_bu_futuristic_trends =
      result?.account_bu_futuristic_trends || [];

    finalResult.account_bu_key_competitors =
      result?.account_bu_key_competitors?.[0]?.data || [];

    finalResult.business_unit_overview =
      result?.business_unit_overview?.[0]?.text || "";

    finalResult.customer_segment_and_key_customers =
      result?.customer_segment_and_key_customers?.[0]?.data || [];

    finalResult.growth_opportunities_shortlisted_markets =
      result?.growth_opportunities_shortlisted_markets?.[0]?.data || [];

    finalResult.key_products_services =
      result?.key_products_services?.[0]?.data || [];

    finalResult.mcp_pain_point = result?.mcp_pain_point?.[0]?.data || [];

    finalResult.business_units = result?.business_units?.[0] || [];

    result = {};

    // console.log(result);
    return finalResult;
  } catch (error) {
    console.log(error);
    console.error("Fetch BU Account details error:", error);
    throw error;
  }
};

/*
const getSortedNudges = (nudges) => {
  const sortedNudges = nudges.map(category => {
    return {
        ...category,
        data: category.data.sort((a, b) => {
            const dateA = new Date(displayFormattedDate(a.published_date, 'YYYY-MM-DD'));
            const dateB = new Date(displayFormattedDate(b.published_date, 'YYYY-MM-DD'));

            // Compare by published_date (latest first)
            if (dateA > dateB) return -1;
            if (dateA < dateB) return 1;

            // If dates are the same, compare by relevance_score (largest first)
            return b.relevance_score - a.relevance_score;
        })
    };
  });

  return sortedNudges;
}
*/

/*
const getSortedNudges = (nudges) => {
  // Sort nudges based on event_date and impact_score
  return nudges.sort((a, b) => {
    const dateA = new Date(displayFormattedDate(a.event_date, "YYYY-MM-DD"));
    const dateB = new Date(displayFormattedDate(b.event_date, "YYYY-MM-DD"));

    // Compare by event_date (latest first)
    if (dateA > dateB) return -1;
    if (dateA < dateB) return 1;

    // If event_date is the same, compare by impact_score (largest first)
    return b.impact_score - a.impact_score;
  });
};
*/

const getSortedNudges = (nudges) => {
  return nudges.sort((a, b) => {
    // Ensure event_date is in a valid format for Safari
    const dateA = new Date(displayFormattedDate(a.event_date, "YYYY-MM-DD").replace(/-/g, "/"));
    const dateB = new Date(displayFormattedDate(b.event_date, "YYYY-MM-DD").replace(/-/g, "/"));

    if (isNaN(dateA) || isNaN(dateB)) return 0; // Handle invalid dates

    // Compare by event_date (latest first)
    if (dateA > dateB) return -1;
    if (dateA < dateB) return 1;

    // If event_date is the same, compare by impact_score (largest first)
    return (b.impact_score || 0) - (a.impact_score || 0);
  });
};


export const fetchAccountBUNudges = async (
  accountName,
  clientName,
  business_unit
) => {
  try {

    let API_URL = "/chatgpt/v2/get_nudges"
    const response = await iq_api.post(API_URL, {
      account: accountName,
      client: clientName,
      business_unit: business_unit,
    });

    let result = response?.data?.records ?? [];
    const version =  response?.data?.version

    // Process and normalize the data
    result?.forEach((category, index) => {
      category.id = index; // Assign Id to each category

      // Iterate over the data array in each category
      category.data?.forEach((nudgeData) => {
        // Iterate over the nudges array inside each nudgeData
        nudgeData.nudges?.nudges?.forEach((nudge, index_2) => {
          nudge.id = index + "_" + index_2;
          // Normalize relevant_solutions to an array if it's not already an array
          if (typeof nudge?.relevant_solutions === "string") {
            nudge.relevant_solutions = [];
          } else if (
            nudge?.relevant_solutions &&
            typeof nudge?.relevant_solutions === "object" &&
            !Array.isArray(nudge?.relevant_solutions)
          ) {
            // Convert object to an array of keys
            nudge.relevant_solutions = Object.keys(nudge.relevant_solutions);
          }

          // Normalize value_selling_prompters to an array if it's not already an array
          if (typeof nudge?.value_selling_prompters === "string") {
            nudge.value_selling_prompters = [];
          } else if (
            nudge?.value_selling_prompters &&
            typeof nudge?.value_selling_prompters === "object" &&
            !Array.isArray(nudge?.value_selling_prompters)
          ) {
            // Convert object to an array of keys
            nudge.value_selling_prompters = Object.keys(
              nudge.value_selling_prompters
            );
          }
        });
      });
    });

    /*
    // Assign Id
    result?.forEach((nudge_data, index) => {
      nudge_data.id = index;

      // Normalize relevant_solutions to an array if it is an object
      if (typeof nudge_data?.relevant_solutions === 'string'){
        nudge_data.relevant_solutions = []
      }
      else if (nudge_data?.relevant_solutions && typeof nudge_data?.relevant_solutions === "object" && !Array.isArray(nudge_data?.relevant_solutions)) {
          // Convert object to an array of keys
          nudge_data.relevant_solutions = Object.keys(nudge_data.relevant_solutions);
      }

      // Normalize relevant_solutions to an array if it is an object
      if (typeof nudge_data?.value_selling_prompters === 'string'){
        nudge_data.value_selling_prompters = []
      }
      else if (nudge_data?.value_selling_prompters && typeof nudge_data?.value_selling_prompters === "object" && !Array.isArray(nudge_data?.value_selling_prompters)) {
          // Convert object to an array of keys
          nudge_data.value_selling_prompters = Object.keys(nudge_data.value_selling_prompters);
      }

    });
    */

    // result = getSortedNudges(result)

    return {result,version};
  } catch (error) {
    console.log(error);
    console.error("Fetch Account BU Nudges error:", error);
    throw error;
  }
};


export const fetchOpportunityContacts = async (opportunityId) => {
  try {
    const response = await iq_api.post(
      "/chatgpt/v2/get_nudge_contacts",
      { id: opportunityId },  // Request body

    );

    

    let result = response?.data?.records ?? [];
    return result;
  } catch (error) {
    console.error("Fetch Opportunity Contacts error:", error);
    throw error;
  }
};

export const fetchClientNudges = async (clientName) => {
  if (!clientName) {
    return [];
  }
  try {
    const response = await iq_api.post("/client/nudges", {
      client: clientName,
    });

    let result = response?.data?.records ?? [];

    result = getSortedNudges(result);

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Client Nudges error:", error);
    throw error;
  }
};

export const fetchAccountBUUseCaseQuestions = async (
  accountName,
  clientName,
  business_unit,
  use_case
) => {
  let params = {
    account: accountName,
    client: clientName,
    business_unit: business_unit,
    use_case: use_case,
  };

  try {
    const response = await iq_api.post(
      "/chatgpt/get_key_questions_and_email",
      params
    );

    let result = response?.data?.records ?? [];

    /*** Transform Data */

    if (use_case === "for_tab") {
      let transformed_prompter_questions_tab = {};

      if (
        result?.prompter_questions_tab?.data &&
        typeof result?.prompter_questions_tab?.data === "object" &&
        Object.entries(result?.prompter_questions_tab?.data).length
      ) {
        // console.log("AAA result.prompter_questions_tab.data: ", result.prompter_questions_tab.data)

        transformed_prompter_questions_tab = {
          data: Object.entries(result?.prompter_questions_tab?.data).map(
            ([name, { use_cases }]) => ({
              name,
              use_cases,
            })
          ),
        };
      }

      // Set the transformed data or default to an empty array
      result.prompter_questions_tab = Object.keys(
        transformed_prompter_questions_tab
      ).length
        ? transformed_prompter_questions_tab
        : {};

      result?.prompter_questions_tab?.data?.map((data, index) => {
        data.number_of_use_cases = data?.use_cases?.length || 0;
        data?.use_cases?.map((use_case, index_2) => {
          use_case.id = index + "_" + index_2;
        });
      });

      // Sort by number_of_use_cases (descending) and then by name (alphabetical ascending)
      result?.prompter_questions_tab?.data?.sort((a, b) => {
        if (b.number_of_use_cases !== a.number_of_use_cases) {
          return b.number_of_use_cases - a.number_of_use_cases; // Primary sort (descending)
        }
        return (a.name || "").localeCompare(b.name || ""); // Secondary sort (alphabetical ascending)
      });
    }

    // console.log("result.prompter_questions_tab : ", result.prompter_questions_tab)

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Account BU Market questions error:", error);
    throw error;
  }
};

export const fetchAccountBUUseCaseDescription = async (
  accountName,
  clientName,
  business_unit,
  use_case
) => {
  try {
    const response = await iq_api.post("/opportunities/usecase_narrative", {
      account: accountName,
      client: clientName,
      business_unit: business_unit,
      use_case: use_case,
    });

    let result = response?.data?.records?.description?.[0] ?? "";

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Account BU Market use case description error:", error);
    throw error;
  }
};

export const fetchGrowthOpportunitiesByAccountAndClient = async (
  accountId,
  accountName,
  clientName
) => {
  try {
    const response = await iq_api.post("/opportunities/use-cases", {
      account_name: accountName,
      client_name: clientName,
    });

    let result = response?.data?.records ?? [];

    return {
      opportunities: result?.opportunities || [],
    };
  } catch (error) {
    setTimeout(function () {
      removeWebpackErrorOverlay();
    }, 1000);

    // Log more specific error details if available
    if (error.response) {
      console.error(`Error ${error.response.status}:`, error.response.data);
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error in setting up request:", error.message);
    }

    // Re-throw error to propagate it up the call stack
    throw error;
  }
};

export const fetchClientsAccountsList = async (accountId, clientName, request_id_arr = []) => {
  try {

    const formData = new FormData();
    formData.append("client_name", clientName);

    if(request_id_arr.length){
        request_id_arr.forEach(id => {
        formData.append("request_id_arr", id);
      });
    }

    const response = await iq_api.post("/client/accounts", formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    let result = response?.data?.records ?? [];

    let finalResult = {};
    finalResult.accounts = result?.accounts || [];

    return finalResult;
  } catch (error) {
    console.log(error);
    console.error("Fetch Clients Accounts List error:", error);
    throw error;
  }
};

export const fetchCompanyFinancials = async (accountName,ticker) => {
  try {
    const obj = {
      account: accountName
    };
    obj.ticker=ticker
    const response = await iq_api.post("/account/financials", obj);

    let result = response?.data?.records ?? [];

    return result || [];
  } catch (error) {
    console.error("Fetch Accounts Financials error:", error);
    throw error;
  }
};

export const fetchCompanyBuFinancials = async (accountId, accountName, business_unit) => {
  try {
    const response = await iq_api.post("/account/business_unit_financials", {
      account: accountName,
      business_unit: business_unit
    });

    let result = response?.data?.records?.[0] ?? [];
    let finalResult = {}
    finalResult.data = result || [];

    return finalResult || [];
  } catch (error) {
    console.error("Fetch Accounts Financials error:", error);
    throw error;
  }
};

export const fetchClientProductOpportunities = async (
  accountId,
  accountName,
  clientName
) => {
  try {
    const response = await iq_api.post(
      "/chatgpt/client_product_opportunities",
      {
        account: accountName,
        client: clientName,
      }
    );

    let result = response?.data ?? [];

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Account details error:", error);
    throw error;
  }
};

function getDistinctContactsCounts(data, field) {
  const counts = {};

  data.forEach((item) => {
    let value = item[field] || "Other"; // Default to 'Other' if field is null, undefined, or empty
    if (value.toLowerCase() === "others") {
      value = "Other"; // Normalize 'Others' to 'Other'
    }
    counts[value] = (counts[value] || 0) + 1;
  });

  const entries = Object.entries(counts).map(([name, count]) => ({
    name,
    count,
  }));
  entries.sort((a, b) =>
    a.name === "Other" ? 1 : b.name === "Other" ? -1 : 0
  ); // Ensure 'Other' is last
  return entries;
}

export const fetchAccountContacts = async (accountName) => {
  try {
    const response = await iq_api.post("/account/contacts", {
      company: accountName,
    });

    let result = response?.data?.records ?? [];

    // result = result.splice(0, 4);

    result = result.map((item) => {
      return {
        ...item,
        function: (typeof item?.function === undefined || item?.function === "" || item?.function?.toLowerCase() == "other" || item?.function?.toLowerCase() == "others") ? "Other" : item?.function,
        management_level: (typeof item?.management_level === undefined || item?.management_level === "" || item?.management_level?.toLowerCase() == "other" || item?.management_level?.toLowerCase() == "others") ? "Other" : item?.management_level,
      };
    });

    const finalResult = {
      records: result,
      filters: {
        function: getDistinctContactsCounts(result, "function"),
        management_level: getDistinctContactsCounts(result, "management_level"),
      },
    };

    return finalResult;
  } catch (error) {
    console.log(error);
    console.error("Fetch Account details error:", error);
    throw error;
  }
};

export const fetchCompanyKeyCompetitorsTable = async (ticker) => {
  try {
    const response = await iq_api.post("/account/competitor_analysis", {
      ticker: ticker
    });

    let result = response?.data?.records ?? [];

    return result || [];
  } catch (error) {
    console.error("Fetch Company Key Competitors Table error:", error);
    throw error;
  }
};

export const fetchTechnologyLandscape = async (company) => {
  try {
    const response = await iq_api.post("/account/vendors", {
      company: company
    });

    let result = response?.data?.records ?? [];
    //console.log(result);
    return result || [];
  } catch (error) {
    console.error("Fetch Technology Landscape error:", error);
    throw error;
  }
};
export const fetchKeyTechnologies = async (company) => {
  try {
    const response = await iq_api.post("/account/key_technologies", {
      account: company
      //account: 'THE BOEING COMPANY'
    });

    let result = response?.data?.records ?? [];
    //console.log(result);
    return result || [];
  } catch (error) {
    console.error("Fetch Key Technology error:", error);
    throw error;
  }
}; 
export const fetchNewProjects = async (ticker) => {
  try {
    const response = await iq_api.post("account/projects", {
      ticker: ticker
      //ticker: 'BA:NYSE'
    });

    let result = response?.data?.records ?? [];
    //console.log(result);
    return result || [];
  } catch (error) {
    console.error("Fetch New Projects error:", error);
    throw error;
  }
};


export const fetchFinancials = async (ticker) => {
  try {
    const response = await iq_api.post("/account/self_financials", {
      ticker: ticker
    //  ticker: 'BA:NYSE'
    });

    let result = response?.data?.records ?? [];
    return result || [];
  } catch (error) {
    console.error("Fetch Financials error:", error);
    throw error;
  }
};

export const fetchDocuments = async (ticker) => {
  try {
    const response = await iq_api.post("/account/documents", {
      ticker: ticker
    //  ticker: 'BA:NYSE'
    });

    let result = response?.data?.records ?? [];
    return result || [];
  } catch (error) {
    console.error("Fetch Documents error:", error);
    throw error;
  }
};

export const fetchBusinessRevenueAnalysis = async (ticker) => {
  
  try {
    var response = []
    if(ticker){
      response = await iq_api.post('/client/revenue_analysis', {'company': ticker}, {
        
      });
    }
    let revenueAnalysisData = response?.data?.business_units || []

    return revenueAnalysisData;
  } catch (error) {
    console.error("Fetch fetchBusinessRevenueAnalysis error:", error);
    throw error;
  }
}

export const fetchGeoWiseRevenueAnalysis = async (ticker) => {
  
  try {
    var response = []
    if(ticker){
      response = await iq_api.post('/chatgpt/geo-segments', { ticker: ticker });
    }
    let revenueAnalysisData = response?.data || [];

    return revenueAnalysisData;
  } catch (error) {
    console.error("Fetch fetchGeoWiseRevenueAnalysis error:", error);
    throw error;
  }
}

export const fetchChatRequestResponse = async (question_string, client_company_name) => {
  
  let requestObjParam = {}
  //requestObjParam.username = "mnm-internal";
  // requestObjParam.Password = "Ks$a_(*Bhjsa@bv%$6^l";
  requestObjParam.input = question_string;
  requestObjParam.client_name = client_company_name;

  try {
    var response = []
    if(question_string){
      response = await iq_api.post('/chatgpt/aiq-copilot', requestObjParam);
    }

    return response.data || {};
  } catch (error) {
    console.error("Fetch chatgpt/aiq-copilot error:", error);
    throw error;
  }
}

export const fetchChatRequestFollowUp = async (question_string, client_name) => {
  
  let requestObjParam = {}
  //requestObjParam.username = "mnm-internal";
  // requestObjParam.Password = "Ks$a_(*Bhjsa@bv%$6^l";
  requestObjParam.input = question_string;
  requestObjParam.client_name = client_name;

  try {
    var response = []
    if(question_string){
      response = await iq_api.post('/chatgpt/aiq-followup', requestObjParam);
    }

    return response.data || {};
  } catch (error) {
    console.error("Fetch chatgpt/follow-up error:", error);
    throw error;
  }
}

export const fetchDefaultAccountsQuestions = async (
  accountId,
  accountName,
  clientName
) => {
  try {
    const response = await iq_api.post("/account/chat-question_templates", {
      account: accountName,
      client: clientName,
    });

    let result = response?.data?.records ?? [];
    return result;
    
  } catch (error) {
    setTimeout(function () {
      removeWebpackErrorOverlay();
    }, 1000);

    // Log more specific error details if available
    if (error.response) {
      console.error(`Error ${error.response.status}:`, error.response.data);
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error in setting up request:", error.message);
    }

    // Re-throw error to propagate it up the call stack
    throw error;
  }
};

export const updateData = async (apiType, data) => {
  try {
    var response = [];
    response = await api.post('/'+apiType+'/update_status_field', data);
    let updateDataStatus = response || [];
    return updateDataStatus;
  } catch (error) {
    console.error("Update Data error:", error);
    throw error;
  }
}


export const fetchSegments = async (accountName) => {
  try {
    const response = await iq_api.post("/chatgpt/segments", {
      company: accountName,
    });
    return response;
  } catch (error) {
    console.error("fetchSegments Data error:", error);
    throw error
  }
}

export const fetchKeyConversations = async (accountName) => {
  try {
    const response = await iq_api.post("/chatgpt/key_conversations", {
      company: accountName,
    });
    return response;
  } catch (error) {
    console.error("fetchKeyConversations Data error:", error);
    throw error
  }
}

export const fetchClosureAgent = async (
  clientName = '',
  accountName = '',
  contact = '',
  context = '',
  contextFile = null,
  outputFile = null,
  responseType = ''
) => {
  try {
    const formData = new FormData();
    formData.append("client_name", clientName);
    formData.append("account_name", accountName);
    formData.append("context", context);
    formData.append("persona_name", contact);
    formData.append("response_type", responseType);

    if (contextFile) {
      formData.append("contextFile", contextFile); // Append the PDF/DOCX file
    }

    if (outputFile) {
      formData.append("outputFile", outputFile); // Append the PDF/DOCX file
    }

    const response = await api.post("/notes/get_closure_note", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      responseType: responseType === 'pdf' ? 'blob' : 'json',
    });

    if (responseType === 'pdf') {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'closure_note.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return true;
    } else {
      let result = response?.data?.result ?? [];
      return result;
    }
  } catch (error) {
    console.log(error);
    console.error("Fetch Closure Agent Error:", error);
    throw error;
  }
};


export const fetchChampionAgent = async (
  contact = '',
  context = '',
  responseType = 'pdf',
  contactOrg = '',
  contactDesignation = ''
) => {
  try {
    let contact_updated = contact.replace(/ /g, "_");
    const formData = new FormData();
    formData.append("contact_name", contact_updated);
    formData.append("context", context);
    formData.append("response_type", responseType);
    formData.append("contact_org", contactOrg);
    formData.append("contact_designation", contactDesignation);

    // const response = await api.post("/notes/get_champion_note", {
    //   params: {
    //     contact_name: contact_updated,
    //     context: context,
    //   },
    // });

    // const response = await api.post("/notes/get_champion_note", formData, {
    //   headers: {
    //     "Content-Type": "multipart/form-data"
    //   },
    //   responseType: responseType === 'pdf' ? 'blob' : 'json',
    // });

    const response = await iq_api_v2.post("/champion_note/champion_note", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      responseType: responseType === 'pdf' ? 'blob' : 'json',
    });

    if (responseType === 'pdf') {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'champion_note.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return true;
    } else {
      let result = response?.data.html ?? [];
      return result;
    }

  } catch (error) {
    console.log(error);
    console.error("Fetch Champion Agent Error:", error);
    throw error;
  }
};

export const fetchDeliveryExcellenceAgent = async (
  clientName = '',
  accountName = '',
  context = '',
  contextFile = null,
  outputFile = null,
  contact = '',
  response_type = ''
) => {
  try {
    const formData = new FormData();
    formData.append("client_name", clientName);
    formData.append("account_name", accountName);
    formData.append("context", context);

    if (contextFile) {
      formData.append("contextFile", contextFile);
    }

    if (outputFile) {
      formData.append("outputFile", outputFile);
    }
    formData.append("contact_name", contact);

    if (response_type) {
      formData.append("response_type", response_type);
    }

    const response = await api.post("/notes/get_delivery_excellence", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      responseType: response_type === 'pdf' ? 'blob' : 'json',
    });

    // let result = response?.data?.result ?? [];
    // return result;

    if (response_type === 'pdf') {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'delivery_excellence.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return true;
    } else {
      let result = response?.data?.result ?? [];
      return result;
    }

  } catch (error) {
    console.log(error);
    console.error("Fetch Delivery Excellence Agent Error:", error);
    throw error;
  }
};

export const fetchRenewalAgent = async (
  accountName = '',
  personaName = '',
  consumptionDataFile = null,
  outputFile = null,
  account_id = '',
  response_type = ''
) => {
  try {
    const formData = new FormData();
    formData.append("account_name", accountName);
    formData.append("contact_name", personaName);
    formData.append("account_id", account_id);

    if (consumptionDataFile) {
      formData.append("consumption_data", consumptionDataFile); // Append file
    }

    if (outputFile) {
      formData.append("outputfile", outputFile); // Append file
    }

    if (response_type) {
      formData.append("response_type", response_type);
    }

    const response = await api.post("/notes/get_renewal_note", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      responseType: response_type === 'pdf' ? 'blob' : 'json',
    });

    // let result = response?.data?.result ?? [];
    // return result;

    if (response_type === 'pdf') {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'renewal_note.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return true;
    } else {
      let result = response?.data?.result ?? [];
      return result;
    }

  } catch (error) {
    console.log(error);
    console.error("Fetch Renewal Agent Error:", error);
    throw error;
  }
};


export const fetchLiveAccountsAgent = async (account_name = "") => {
  try {
    // const response = await api.get("/notes/get_live_accounts?account_name="+account_name);
    const response = await api.get(`/notes/get_live_accounts?account_name=${encodeURIComponent(account_name)}`);
    // console.log("LIVE ACCOUNTS: "+JSON.stringify(response));
    let result = response?.data?.data ?? [];
    
    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Renewal Agent Error:", error);
    throw error;
  }
};

export const createDemoRequest = async (
  // requestType = '',
  // roundOfDemo = '',
  // sellerAccountName = '',
  // buyerAccountName = '',
  sellerAccountWebsite = '',
  buyerAccountWebsite = '',
  // sellerIndustry = '',
  // buyerIndustry = '',
  // noOfAccounts = '',
  // noOfUsers = '',
  // accountType = '',
  demoDateTime = '',
  question = '',
  // salesPersonNameAndDesignation = '',
  lead_id = '',
  // icpNameAndDesignation = '',
  clientLinkedinUrl = '',
  productListCsv = null, //file
  csvData = "",

  exploringTools,
  // keyChallenges,
  // otherChallenge,
  kpi,
  growthFocus,
  salesTeamSize,
  // keyAccountsCount,
  // currentTools,
  // otherTool,
  decisionMakers,
  
  
) => {
  try {
    const formData = new FormData();
    // formData.append("requestType", requestType);
    // formData.append("roundOfDemo", roundOfDemo);
    // formData.append("sellerAccountName", sellerAccountName);
    // formData.append("buyerAccountName", buyerAccountName);
    formData.append("sellerAccountWebsite", sellerAccountWebsite);
    formData.append("buyerAccountWebsite", buyerAccountWebsite);
    // formData.append("sellerIndustry", sellerIndustry);
    // formData.append("buyerIndustry", buyerIndustry);
    // formData.append("noOfAccounts", noOfAccounts);
    // formData.append("noOfUsers", noOfUsers);
    // formData.append("accountType", accountType);
    formData.append("demoDateTime", demoDateTime);
    formData.append("question", question);
    // formData.append("salesPersonNameAndDesignation", salesPersonNameAndDesignation);
    formData.append("lead_id", lead_id);
    // formData.append("icpNameAndDesignation", icpNameAndDesignation);
    formData.append("clientLinkedinUrl", clientLinkedinUrl);
    formData.append("csvData", csvData);

    formData.append("exploringTools", exploringTools);
    // formData.append("keyChallenges", keyChallenges);
    // formData.append("otherChallenge", otherChallenge);
    formData.append('kpi', kpi);
    formData.append("growthFocus", growthFocus);
    formData.append("salesTeamSize", salesTeamSize);
    // formData.append("keyAccountsCount", keyAccountsCount);
    // formData.append("currentTools", currentTools);
    // formData.append("otherTool", otherTool);
    formData.append("decisionMakers", decisionMakers);

    if (productListCsv) {
      formData.append("productListCsv", productListCsv); // Append file
    }
    // formData.append("demoStartTime", demoStartTime);
    // formData.append("demoCompletionTime", demoCompletionTime);
    // formData.append("email", email);
    // formData.append("name", name);
    // formData.append("productListCsv", productListCsv);
    // formData.append("readyState", readyState);
    // formData.append("detailsSentToRequestor", detailsSentToRequestor);
    // formData.append("demoFeedback", demoFeedback);
    // formData.append("qcedByProduct", qcedByProduct);
    // formData.append("qcedByResearch", qcedByResearch);
    // formData.append("deliveredToRequestor", deliveredToRequestor);
    
    const response = await api.post("/demo_request/add_demo_request", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });

    // let result = response?.data?.result ?? [];
    // let result = response ?? [];
    let result = response?.data?.result?.message ?? '';

    return result;

  } catch (error) {
    console.log(error);
    console.error("Fetch Renewal Agent Error:", error);
    throw error;
  }
};

export const handleFeedbackDownloadBtn = async (id = "") => {
  try {
      const formData = new FormData();
      formData.append("id", id);

      const response = await api.post(
          "/demo_request/download_feedback_file",
          formData,
          {
              responseType: 'blob', // Important for file downloads
              headers: {
                  'Content-Type': 'multipart/form-data',
              }
          }
      );

      // Get filename from response headers if available
      const contentDisposition = response.headers['content-disposition'];
      const filename = contentDisposition
          ? contentDisposition.split('filename=')[1]
          : 'account_plan.xlsx';

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
      }, 100);

  } catch (error) {
      console.error("Download failed:", error);
      // You might want to add user feedback here (e.g., toast notification)
  }
};

export const handleProductListDownload = async (id = "") => {
  try {
      const formData = new FormData();
      formData.append("id", id);

      const response = await api.post(
          "/demo_request/download_product_file",
          formData,
          {
              responseType: 'blob', // Important for file downloads
              headers: {
                  'Content-Type': 'multipart/form-data',
              }
          }
      );

      // Get filename from response headers if available
      const contentDisposition = response.headers['content-disposition'];
      const filename = contentDisposition
          ? contentDisposition.split('filename=')[1]
          : 'account_plan.xlsx';

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
      }, 100);

  } catch (error) {
      console.error("Download failed:", error);
      // You might want to add user feedback here (e.g., toast notification)
  }
};

export const getDemoRequestsCreateAccount = async () => {
  try {
    const response = await api.get("/demo_request/get_list_to_create_account");
    let result = response?.data?.data ?? [];

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Renewal Agent Error:", error);
    throw error;
  }
};

export const getDemoRequestsToMapAccount = async () => {
  try {
    const response = await api.get("/demo_request/get_list_to_map_account");
    let result = response?.data?.data ?? [];

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Renewal Agent Error:", error);
    throw error;
  }
};

export const getSalesUsers = async () => {
  try {
    const response = await api.get("/users/get_sales_users_list");
    let result = response?.data?.data ?? [];
    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Renewal Agent Error:", error);
    throw error;
  }
};

export const fetchNudgesNew = async (clientName, accountName) => {
  try {
    const update_data = {
      client: clientName,
      account: accountName
    };
    const queryString = qs.stringify(update_data, { skipNulls: false });
    const response = await iq_api_v2.post("/nudges_v2/fetch_nudges?"+queryString);
    let result = response?.data ?? [];
    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Nudges Error:", error);
    throw error;
  }
};